import DapDSCommandItem from './command-item.component'

export * from './command-item.component'
export default DapDSCommandItem

DapDSCommandItem.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-command-item': DapDSCommandItem
  }
}
